import { Box, ButtonBase } from '@mui/material'
import { styled } from '@mui/system'
import { colors } from '../../utils/colorUtils'

const Container = styled(Box)(({ theme }) => ({
  float: 'left',
  marginLeft: theme.spacing(1.5),
  padding: theme.spacing(0.4),
  backgroundColor: colors.awaOffWhite,
  borderRadius: '10px',
}))

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.common.white,
  height: 75,
  width: 75,
  '&:hover, &.Mui-focusVisible': {
    zIndex: 1,
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
    '& .MuiTypography-root': {
      border: '4px solid currentColor',
    },
  },
  [theme.breakpoints.down('sm')]: {
    height: 60,
    width: 60,
  },
}))

const ImageBackdrop = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.black,
  opacity: 0.4,
  transition: theme.transitions.create('opacity'),
  borderRadius: '6px',
}))

const ImageLabel = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: theme.spacing(0.5),
  display: 'flex',
  justifyContent: 'center',
  color: theme.palette.common.white,
  fontSize: 12,
}))

const ImageSrc = styled('span')({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '6px',
})

const BasemapButton = ({ displayName, iconUrl, onClick, name }) => {
  return (
    <Container>
      <ImageButton focusRipple key={name} onClick={onClick}>
        <ImageSrc style={{ backgroundImage: `url(${iconUrl})` }} />
        <ImageBackdrop className="MuiImageBackdrop-root" />
        <ImageLabel>{displayName}</ImageLabel>
      </ImageButton>
    </Container>
  )
}

export default BasemapButton
